<template>
    <div class="candidatos">
        <div v-if="loader" class="column align-center justify-center">
            <Loader layout="small" />
        </div>
        <template v-else>
            <div class="container" v-if="list.length > 0">
                <div v-for="(s, i) in list" class="row line align-center" :key="s.id">
                    <div class="grid-2">
                        <label>Nome</label>
                        <div>{{ s.nome_doutor }}</div>
                    </div>
                    <div class="grid-2">
                        <label>UF/Cidade</label>
                        <div>{{ s.estado }}/{{ s.cidade }}</div>
                    </div>
                    <div class="grid-2">
                        <label>Celular</label>
                        <div>{{ s.celular_doutor | phone }}</div>
                    </div>
                    <div class="grid-3">
                        <label>E-mail</label>
                        <div>{{ s.email_doutor }}</div>
                    </div>
                    <div v-if="i == 0" class="grid-3 text-right">
                        <Button v-if="!show" @click="show = true" layout="red-go">DESCARTAR</Button>
                        <Button v-if="!show" @click="seleciona(s.id)" :loader="bloader" layout="green-go"
                            style="margin-left:12px">SELECIONAR</Button>
                        <div v-if="show" class="grid-11 text-left">
                            <label style="margin-bottom: 4px" class="row justify-space">Motivo Descarte <i
                                    title="CANCELAR" @click="show = false" style="margin-right:-10px"
                                    class="pointer fa fa-times text-red font-22" /></label>
                            <input v-model="motivo" placeholder="Motivo Descarte"><br><br>
                            <Button :loader="bloader" @click="() => descartar(s.id)" layout="red-go">DESCARTAR</Button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no" v-else>NÃO POSSUI CANDIDATOS.</div>
        </template>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader";

export default {
    name: "Candidatos",
    components: { Button, Loader },
    props: { job: Object, cb: Function },
    data() {
        return {
            loader: true,
            bloader: false,
            show: false,
            motivo: "",
            list: [],
        };
    },
    methods: {
        ...mapActions("job", ["CANDIDATOS", "DESCARTAR", "SELECIONA_CANDIDATO"]),
        async load() {
            this.loader = true;
            await this.CANDIDATOS(this.job.id).then(({ data }) => this.list = data || []);
            this.loader = false
        },
        async descartar(ID) {
            this.bloader = true;
            await this.DESCARTAR({ job: this.job.id, id: ID, motivo_descarte: this.motivo });
            this.show = false
            this.bloader = false;
            this.load()
        }, async seleciona(ID) {
            this.bloader = true;
            await this.SELECIONA_CANDIDATO({ job: this.job.id, id: ID });
            this.show = false
            this.bloader = false;
            this.cb()
        },
    },
    beforeMount() { this.load() }
};
</script>

<style lang="sass" scoped>
  @use "@/assets/scss/vars.scss" as *
  .candidatos
    padding: 10px 30px
    overflow: auto
    .container
        min-width: 1400px
        padding-bottom: 30px
        overflow: hidden
        .line
            padding: 20px 10px
            font-size: 16px
            &:nth-child(odd)
                background: #eee
            span
                color: $purple
                font-size: 14px
            label
                color: $purple
    .title
        font-weight: bold
        padding: 16px 6px
        opacity: .6
        background: $purple
        color: white
        font-size: 18px
    .no
        color: $gray-1
        font-size: 16px
        padding: 30px 60px
  </style>